import { Next } from '@securitize/ui-components';

export const authoriseWalletNext = new Next('/wallets', 'AUTHORISE_WALLET', { method: 'post' });
export const SAVE_TEMP_AUTH_WALLET_DATA = 'SAVE_TEMP_AUTH_WALLET_DATA';
export const GET_WALLETS_NEXT = new Next('/wallets', 'GET_WALLETS_NEXT');
